import * as React from "react"
import { AppTableExportMenu } from "@components"

const DOWNLOAD_OPTIONS = [
    { label: 'Retailer by Column', icon: 'table-columns', extraData: { retailersAsColumns: true } },
    { label: 'Retailer by Row', icon: 'table-list', extraData: {} },
]

export default function MonitoringResultsTableExcelButton({ onDownload }) {
    return <AppTableExportMenu
        onDownloadExcel={onDownload}
        downloadCSVOptions={DOWNLOAD_OPTIONS}
    />
}
